export const createUrl = (tab, scopeType, scopeId) => {
  if (scopeId) {
    return `/api/scheduling/${tab}/${scopeType}/${scopeId}`
  }
  if (scopeType) {
    return `/api/scheduling/${tab}/${scopeType}`
  }
  return `/api/scheduling/${tab}`
}
